import type { ProductOptionFieldsFragment } from '../../../__generated__/graphql-client-types';
import { type OptionSelection } from '../../../types/product-option.types';
import { isCurrentOptionSelected } from './product-option.helper';

export const changeOption = (option: ProductOptionFieldsFragment, selections?: OptionSelection[]): ProductOptionFieldsFragment => {
	return { ...option, selected: !isCurrentOptionSelected(option, selections, true) };
};
